export default "__VITE_ASSET__U47lAPZj__"